import { throwError } from "@lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import {
  Workflow,
  WorkflowList,
  WorkflowPayload,
} from "@/utils/types/workflowMain";

const basePath = "/workflow/workflows";

class WorkflowService {
  getAllWorkflows = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }): Promise<WorkflowList> => {
    return await get<WorkflowList>(`${basePath}/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getWorkflowById = async (id: string): Promise<Workflow> => {
    if (!id) {
      throwError("ID is required", "WorkflowService");
    }
    return await get<Workflow>(`${basePath}/${id}/`);
  };

  createWorkflow = async (payload: WorkflowPayload): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "WorkflowService");
    }
    return await post(`${basePath}/`, payload);
  };

  updateWorkflow = async (
    id: string,
    payload: WorkflowPayload
  ): Promise<any> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "WorkflowService");
    }
    return await put(`${basePath}/${id}/`, payload);
  };

  deleteWorkflow = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "WorkflowService");
    }
    return await del(`${basePath}/${id}/`);
  };
}

const instance = new WorkflowService();
export default instance;
